import { render, staticRenderFns } from "./OverallData.vue?vue&type=template&id=95d1731a&"
import script from "./OverallData.vue?vue&type=script&lang=js&"
export * from "./OverallData.vue?vue&type=script&lang=js&"
import style0 from "./OverallData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports